module.exports = __webpack_public_path__ + "img/research_apper.e18df847.webp";